import React from 'react';

// The field supervisor's daily update as four questions (Ryan, Oct 14 2026): what they did, how
// it's going, what they need tomorrow, when they think they'll be done. The answers are sent as
// ONE update with a label on each line — "Done today: …" — so every place that reads updates (the
// job feed, the cards, the morning brief, the note sorter) reads it as it always has, and the
// Field Supervisor Scores tile counts the labels to see which questions were answered.
export const QUESTIONS = [
  { key: 'did', label: 'Done today', ask: 'What did you get done today?', ph: 'Set 6 poles, pulled wire on loops 1–4…' },
  { key: 'going', label: "How it's going", ask: 'How is it going?', ph: 'On track — rocky soil slowing the bore' },
  { key: 'need', label: 'Need tomorrow', ask: 'What do you need tomorrow?', ph: '2 more guys, the mini-ex, 500 ft of 2" conduit' },
  { key: 'done', label: 'Done by', ask: 'When do you think you’ll be done?', ph: 'Friday / end of next week / 3 more days' },
];
export const EMPTY_ANSWERS = { did: '', going: '', need: '', done: '' };
export const composeUpdate = a => QUESTIONS.filter(q => String((a || {})[q.key] || '').trim()).map(q => `${q.label}: ${String(a[q.key]).trim()}`).join('\n');
export const hasAnswer = a => QUESTIONS.some(q => String((a || {})[q.key] || '').trim());
export const isSupervisorNow = () => { try { const s = JSON.parse(localStorage.getItem('titan_session') || 'null'); return (s?.role || s?.user?.role || s?.worker?.role) === 'FieldSupervisor'; } catch { return false; } };

export default function FourQuestions({ value, onChange, onFocusField, active = null, autoFocus = false }) {
  const a = value || EMPTY_ANSWERS;
  const answered = QUESTIONS.filter(q => String(a[q.key] || '').trim()).length;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {QUESTIONS.map((q, i) => (
        <label key={q.key} style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <span style={{ fontSize: 12, fontWeight: 800, color: active === q.key ? '#e87722' : '#374151' }}>{i + 1}. {q.ask}</span>
          <textarea value={a[q.key] || ''} rows={q.key === 'did' ? 3 : 2} autoFocus={autoFocus && i === 0}
            onFocus={() => onFocusField && onFocusField(q.key)}
            onChange={e => onChange({ ...a, [q.key]: e.target.value })} placeholder={q.ph}
            style={{ width: '100%', boxSizing: 'border-box', border: `1.5px solid ${active === q.key ? '#e87722' : '#e5e7eb'}`, borderRadius: 10, padding: '10px 12px', fontSize: 16, resize: 'vertical', fontFamily: 'inherit', background: '#fff', color: '#111' }} />
        </label>
      ))}
      <div style={{ fontSize: 12, fontWeight: 700, color: answered === 4 ? '#15803d' : '#9ca3af' }}>{answered} of 4 answered{answered === 4 ? ' ✓' : ''}</div>
    </div>
  );
}
